import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ListIndividualsComponent } from './list-individuals/list-individuals.component';
import { IndividualProfileComponent } from './individual-profile/individual-profile.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: ListIndividualsComponent,
      },
      {
        path: 'profile/:id',
        component: IndividualProfileComponent,
      },
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      { path: '**', redirectTo: 'list', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IndividualsRoutingModule { }
